import React, { Component } from 'react'
import Tag from './Tag'
import { withRouter } from 'react-router'

class Tags extends Component {
    checkKey = (e) => {
        if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
            let allTags = this.state.allTags
            allTags.push(this.state.newTagName)
            this.setState({
                allTags,
                newTagName: ""
            })
        }
    }

    render() {
        let tags = Object.values(this.props.tags)
        if (this.props.query) {
            tags = tags.filter(tag => tag.name.toLowerCase().includes(this.props.query))
        }

        if (this.props.currentTags.length > 0) {
            tags = tags.filter(tag => !this.props.currentTags.includes(tag.name))
        }

        return (
            <ul id="existing-tags-dropdown-bubble" className={`flex overflow-y ${this.props.visible ? "" : "hidden"}`}>
                {tags.length > 0 ? tags.map(tag => {
                    return <Tag key={tag._id} 
                                onClick={(e) => this.props.selectTag(e, tag)}
                                label={tag.name}
                                />
                }) : <div>No Tags Found</div> }
            </ul>
        )
    }
}
export default withRouter(Tags)